import { Component, OnInit } from "@angular/core";
import { DatePipe } from "@angular/common";
import { ActivatedRoute, Router } from "@angular/router";
import { Dashreport } from "../dashreport.model";
import { DashreportService } from "../dashreport.service";
import "rxjs/add/operator/filter";
import "rxjs/add/operator/switchMap";
import { AppRoutingService } from "../../app-routing.service";
import { DashreportListResponse } from "../dashreport-list-reponse.model";
const dayjs = require("dayjs");

@Component({
  selector: "app-dashreport-list",
  templateUrl: "./list.component.html",
  styleUrls: ["./list.component.scss"],
})
export class DashreportListComponent implements OnInit {
  showAlert: boolean;
  loading: boolean = true;
  filterDateType: string = "yesterday";
  dashreportList: Array<Dashreport>;
  dashreportListBase: Array<Dashreport>;

  dashreportListResponse: DashreportListResponse;
  searchValue: string = "";

  constructor(
    private datePipe: DatePipe,
    private router: Router,
    private route: ActivatedRoute,
    private dashreportService: DashreportService,
    private routingService: AppRoutingService
  ) {
    this.dashreportList = new Array<Dashreport>();
    this.dashreportListBase = new Array<Dashreport>();
    this.showAlert = false;
  }

  ngOnInit() {
    this.getDashreportList();
  }

  onClosed(dismissedAlert: any): void {
    dismissedAlert.show = false;
  }

  export(){
    let params = this.getParams();
    if(this.searchValue && this.searchValue.length > 0){
      params = {
        "searcheValue": this.searchValue,
        ...params
      }
    }
    this.dashreportService.exportExcel(params).subscribe((res) => {
        this.saveExcelFile(res);
    });
  }

  saveExcelFile(data: any) {
    
    const decodedData = atob(data);
    const byteArray = new Uint8Array(decodedData.length);
    for (let i = 0; i < decodedData.length; i++) {
      byteArray[i] = decodedData.charCodeAt(i);
    }
    const blob = new Blob([byteArray], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    const timestamp = new Date().getTime();
    const fileName = `report_file_${timestamp}.xlsx`;
    link.download = fileName;
    link.click();
    window.URL.revokeObjectURL(url);
  }

  changeFilterDateType(type) {
    this.filterDateType = type;
    this.getDashreportList();
  }
  openTr(i: any) {
    this.dashreportList[i].open = !this.dashreportList[i].open;
  }

  filterByTitle = (e): void => {
    const val = e.target.value.toUpperCase();
    this.searchValue = val;
    this.dashreportList = this.dashreportListBase;
    if (val) {
      this.dashreportList = this.dashreportList
        .map((p) => ({
          ...p,
          outletMatch: p.title.toUpperCase().includes(val) ? "1" : "0",
          campaignMatch: p.campaignList
            .map((toUp) => toUp.title.toUpperCase())
            .join("")
            .includes(val)
            ? "1"
            : "0",
        }))
        .map((f) => {
          const resValMap: any = {
            10: { ...f },
            11: {
              ...f,
              campaignList: f.campaignList.filter((t) =>
                t.title.toUpperCase().includes(val)
              ),
              registeredConsumer: f.campaignList
                .filter((t) => t.title.toUpperCase().includes(val))
                .reduce((pre, cur) => pre + cur.registeredConsumer, 0),
              open: true,
            },
            "00": false,
            "01": {
              ...f,
              campaignList: f.campaignList.filter((t) =>
                t.title.toUpperCase().includes(val)
              ),
              registeredConsumer: f.campaignList
                .filter((t) => t.title.toUpperCase().includes(val))
                .reduce((pre, cur) => pre + cur.registeredConsumer, 0),
              open: true,
            },
          };
          return resValMap[`${f.outletMatch}${f.campaignMatch}`];
        })
        .filter(Boolean);
    }
  };

  private getParams(): any {
    const filterOptions: any = {
      yesterday: [
        dayjs().subtract(1, 'day').startOf('d').toISOString(),
        dayjs().subtract(1, 'day').endOf('d').toISOString(),
      ],
      "last 7 days": [
        dayjs().subtract(6, "day").startOf("d").toISOString(),
        dayjs().endOf("d").toISOString(),
      ],
      "last 30 days": [
        dayjs().subtract(1, "month").add(1, "day").startOf("d").toISOString(),
        dayjs().endOf("d").toISOString(),
      ],
    };
    let startDate = null;
    let endDate = null;
    if (filterOptions && filterOptions[this.filterDateType]) {
       startDate = filterOptions[this.filterDateType][0];
       endDate = filterOptions[this.filterDateType][1];
    }
    return {startDate, endDate}
  }

  private getDashreportList(): void {
    let params = this.getParams();
    this.loading = true;
    this.dashreportService.getDashReportList(params).subscribe(
      (res) => {
        this.dashreportList = (res.data || []).map((r) => ({
          type: "Outlet",
          title: r.outletName || "--",
          registeredConsumer: r.total || "--",
          associatedUser: "--",
          campaignList: r.campaigns.map((c) => ({
            type: "Campaign",
            title: c.campaignName || "--",
            registeredConsumer: c.total || "--",
            associatedUser: c.userNum || "--",
          })),
        }));
        this.dashreportListBase = this.dashreportList;
        this.loading = false;
        if (this.dashreportList.length === 0) {
          this.showAlert = true;
        }
      },
      (error) => {
        this.dashreportList = [];
        this.showAlert = true;
        this.loading = false;
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/dashreport/list/list.component.ts